(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4087],{

/***/ 32330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/van-leasing",
      function () {
        return __webpack_require__(94270);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_awesome_reveal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81277);
/* harmony import */ var _components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1429);
/* harmony import */ var _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96732);
/* harmony import */ var _components_styleguide_Homepage_Sections_RecentlyViewed__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8947);
/* harmony import */ var _components_styleguide_Homepage_Sections_TopDeals__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24778);
/* harmony import */ var _components_styleguide_Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63383);
/* harmony import */ var _components_views_HomePage_HeroBackground__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8465);
/* harmony import */ var _components_views_HomePage_Search__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17836);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99280);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7158);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16693);














var Brands = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2607).then(__webpack_require__.bind(__webpack_require__, 32607));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32607)
            ];
        }
    }
});
var Grid = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(6388), __webpack_require__.e(6375), __webpack_require__.e(5737)]).then(__webpack_require__.bind(__webpack_require__, 15492));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15492)
            ];
        }
    }
});
var Cards = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(2136)]).then(__webpack_require__.bind(__webpack_require__, 92136));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92136)
            ];
        }
    }
});
var LocoScore = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2345), __webpack_require__.e(3646)]).then(__webpack_require__.bind(__webpack_require__, 3646));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3646)
            ];
        }
    }
});
var HowDoesItWork = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 8420).then(__webpack_require__.bind(__webpack_require__, 88420));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88420)
            ];
        }
    }
});
var ReferAFriend = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 4608).then(__webpack_require__.bind(__webpack_require__, 14608));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14608)
            ];
        }
    }
});
var Testimonials = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(5892)]).then(__webpack_require__.bind(__webpack_require__, 15892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15892)
            ];
        }
    }
});
var VanHomePage = function(param) {
    var heroVehicle = param.heroVehicle, dealList = param.dealList, secondDealList = param.secondDealList, dealCount = param.dealCount;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isVans = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        className: "container-fluid container--content-homepage is-vans",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_3__/* .PageMetaData */ .S, {
                title: _lib_constants__WEBPACK_IMPORTED_MODULE_10__/* .constants.metaData.vanTitle */ ._G.metaData.vanTitle,
                description: _lib_constants__WEBPACK_IMPORTED_MODULE_10__/* .constants.metaData.vanTagLine */ ._G.metaData.vanTagLine,
                pageUrl: _lib_routes__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.vanHomePage.url */ .Z.vanHomePage.url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_13__/* .Fade */ .pT, {
                cascade: true,
                damping: 0.1,
                triggerOnce: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_HomePage_HeroBackground__WEBPACK_IMPORTED_MODULE_8__/* .HeroBackground */ .M, {
                    isVans: isVans,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_HomePage_Search__WEBPACK_IMPORTED_MODULE_9__/* .Search */ .o, {
                        isVans: isVans,
                        popularSearchesVisibility: "all",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Link__WEBPACK_IMPORTED_MODULE_7__/* .InternalLink */ .h, {
                            hasBackground: true,
                            hasPadding: true,
                            hasTransition: true,
                            href: _lib_routes__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.vanSearchPage.url */ .Z.vanSearchPage.url,
                            icon: "Search",
                            theme: _types_system__WEBPACK_IMPORTED_MODULE_12__/* .Theme.dark */ .Q2.dark,
                            hierarchy: _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_4__/* .ButtonHierarchy.Filled */ .B.Filled,
                            size: _types_system__WEBPACK_IMPORTED_MODULE_12__/* .Size.Large */ .$u.Large,
                            children: "Search deals"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Homepage_Sections_RecentlyViewed__WEBPACK_IMPORTED_MODULE_5__/* .RecentlyViewed */ .H, {
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Brands, {
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Homepage_Sections_TopDeals__WEBPACK_IMPORTED_MODULE_6__/* .TopDeals */ .UI, {
                dealList: dealList,
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Homepage_Sections_TopDeals__WEBPACK_IMPORTED_MODULE_6__/* .TopDeals */ .UI, {
                dealList: secondDealList,
                isVans: isVans,
                type: _components_styleguide_Homepage_Sections_TopDeals__WEBPACK_IMPORTED_MODULE_6__/* .NO_DEPOSIT_DEALS */ .CD
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Grid, {
                isVans: isVans,
                dealCount: dealCount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocoScore, {
                deal: heroVehicle,
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cards, {
                isVans: isVans,
                dealCount: dealCount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Testimonials, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowDoesItWork, {
                isVans: isVans
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReferAFriend, {
                isVans: isVans
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (VanHomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1852,5675,1967,264,638,1429,3052,3680,9774,2888,179], function() { return __webpack_exec__(32330); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);